export default {"src":"/_next/static/media/pungo.582b70ea.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};